{
  "GENERAL_SETTINGS": {
    "TITLE": "Nastavenia účtu",
    "SUBMIT": "Aktualizovať nastavenia",
    "BACK": "Späť",
    "DISMISS": "Zamietnuť",
    "UPDATE": {
      "ERROR": "Nastavenia sa nepodarilo aktualizovať, skúste to znova!",
      "SUCCESS": "Úspešne aktualizované nastavenia účtu"
    },
    "FORM": {
      "ERROR": "Prosím, opravte chyby vo formulári",
      "GENERAL_SECTION": {
        "TITLE": "Všeobecné nastavenia",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID účtu",
        "NOTE": "Toto ID je potrebné, ak vytvárate integráciu založenú na rozhraní API"
      },
      "NAME": {
        "LABEL": "Názov účtu",
        "PLACEHOLDER": "Názov vášho účtu",
        "ERROR": "Zadajte platný názov účtu"
      },
      "LANGUAGE": {
        "LABEL": "Jazyk stránky",
        "PLACEHOLDER": "Názov vášho účtu",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Doména prichádzajúceho e-mailu",
        "PLACEHOLDER": "Doména, na ktorú budete dostávať e-maily",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mailová podpora",
        "PLACEHOLDER": "E-mailová podpora vašej spoločnosti",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Počet dní po automatickom vyriešení tiketu, ak sa nevykonáva žiadna aktivita",
        "PLACEHOLDER": "nikdy",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)",
        "NOTE": "Počet hodín neaktivity, po ktorých bude akákoľvek otvorená konverzácia automaticky vyriešená."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Pre vaše konto je povolená kontinuita konverzácie s e-mailami.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Teraz môžete prijímať e-maily vo vlastnej doméne."
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Počet dní, po ktorých sa má prázdna konverzácia automaticky vyriešiť, ak nie je žiadna aktivita",
        "PLACEHOLDER": "nikdy",
        "ERROR": "Zadajte prosím platnú dobu automatického vyriešenia prázdnych konverzácií (minimum 1 deň a maximum 999 dní)"
      },
      "PHONE": {
        "TITLE": "Nastavenia PBX",
        "NOTE": "Konfigurujte pripojenie k vašej PBX pre telefónne hovory",
        "SIP_HOST": {
          "LABEL": "SIP doména"
        },
        "DIALING_MODE": {
          "LABEL": "Režim vytáčania",
          "MODES": {
            "direct": "Priame - hovor sa vytočí okamžite po kliknutí na telefónny odkaz",
            "indirect": "Nepriame - telefónne číslo sa pripraví vo vstupnom poli telefónneho widgetu"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Prístup k nahrávkam hovorov",
          "MODES": {
            "admin_only": "Iba administrátori",
            "admin_and_assigned_agent": "Administrátori a priradený agent",
            "inbox_members": "Všetci agenti s prístupom k schránke"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Nastavenia e-mailu",
        "NOTE": "Upravuje správanie e-mailových schránok"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Režim zobrazenia časovej pečiatky konverzácie",
        "MODES": {
          "both": "Vytvorené a posledná aktivita",
          "last_activity_only": "Iba posledná aktivita",
          "last_customer_message": "Posledná správa zákazníka"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokovať domény s nízkou reputáciou"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Zahrnúť pôvodnú správu do odpovede na e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automaticky vyriešiť novú konverzáciu"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automaticky presunúť novú e-mailovú konverzáciu do schránky robota, ktorý spracoval objednávky kontaktu"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Rozšírené štítky - Povoliť dlhšie názvy štítkov s väčším popup rozhraním"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Automaticky priradiť konverzáciu agentovi, ktorý vytvoril poslednú odpoveď"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Režim push notifikácií",
        "MODES": {
          "all_inboxes": "Všetky schránky - Odosielať notifikácie pre všetky typy kanálov",
          "chat_only": "Iba chat - Odosielať notifikácie iba pre ne-e-mailové kanály"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Povoliť prepínanie podpisu pri odoslaných správach"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Zobraziť stav chatu agenta na wallboarde"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Zobraziť úplné názvy príloh bez skrátenia"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Prihlásenie heslom",
        "MODES": {
          "allowed_for_all": "Povolené pre všetkých používateľov",
          "allowed_for_agents_only": "Povolené iba pre agentov (administrátori musia používať OAuth)",
          "password_login_disabled": "Zakázané - iba OAuth"
        }
      }
    },
    "LEARN_MORE": "Zistiť viac",
    "PAYMENT_PENDING": "Vaša platba čaká na spracovanie. Aktualizujte svoje platobné údaje, aby ste mohli naďalej používať kontaktné centrum",
    "LIMITS_UPGRADE": "Váš účet prekročil limity používania. Zvýšte si plán, aby ste mohli naďalej používať kontaktné centrum",
    "OPEN_BILLING": "Otvoriť fakturáciu",
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Prekročili ste limit konverzácií. Plán Hacker umožňuje iba 500 konverzácií.",
      "INBOXES": "Prekročili ste limit schránok. Plán Hacker podporuje iba live chat na webovej stránke. Dodatočné schránky ako e-mail, WhatsApp atď. vyžadujú platený plán.",
      "AGENTS": "Prekročili ste limit agentov. Plán Hacker umožňuje iba 2 agentov.",
      "NON_ADMIN": "Kontaktujte prosím svojho administrátora a požiadajte o upgrade plánu, aby ste mohli naďalej používať všetky funkcie."
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Odstrániť váš účet",
      "NOTE": "Po odstránení vášho účtu budú všetky vaše údaje odstránené.",
      "BUTTON_TEXT": "Odstrániť váš účet",
      "CONFIRM": {
        "TITLE": "Odstrániť účet",
        "MESSAGE": "Odstránenie vášho účtu je nevratné. Pre potvrdenie trvalého odstránenia zadajte nižšie názov účtu.",
        "BUTTON_TEXT": "Odstrániť",
        "DISMISS": "Zrušiť",
        "PLACE_HOLDER": "Pre potvrdenie zadajte {accountName}"
      },
      "SUCCESS": "Účet bol označený na odstránenie",
      "FAILURE": "Nepodarilo sa odstrániť účet, skúste to znova!",
      "SCHEDULED_DELETION": {
        "TITLE": "Účet naplánovaný na odstránenie",
        "MESSAGE_MANUAL": "Tento účet je naplánovaný na odstránenie {deletionDate}. Toto si vyžiadal administrátor. Odstránenie môžete zrušiť pred týmto dátumom.",
        "MESSAGE_INACTIVITY": "Tento účet je naplánovaný na odstránenie {deletionDate} z dôvodu neaktivity účtu. Odstránenie môžete zrušiť pred týmto dátumom.",
        "CLEAR_BUTTON": "Zrušiť naplánované odstránenie"
      }
    },
    "NEW_VERSION_AVAILABLE": "Je dostupná nová verzia. Znova načítajte stránku pre získanie najnovších aktualizácií.",
    "RELOAD_NOW": "Aktualizovať teraz"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Stlačením tlačidla enter vyberte",
      "ENTER_TO_REMOVE": "Stlačením tlačidla enter vymažte",
      "NO_OPTIONS": "Zoznam je prázdny",
      "NO_RESULT": "Nenašli sa žiadne výsledky",
      "SELECT_ONE": "Vyberte jeden",
      "SELECT": "Vybrať"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Upozornenia",
    "MARK_ALL_DONE": "Označiť všetky ako hotové",
    "DELETE_TITLE": "odstránené",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Neprečítané upozornenia",
      "ALL_NOTIFICATIONS": "Zobraziť všetky upozornenia",
      "LOADING_UNREAD_MESSAGE": "Načítavajú sa neprečítané upozornenia...",
      "EMPTY_MESSAGE": "Nemáte žiadne neprečítané upozornenia"
    },
    "LIST": {
      "404": "Žiadne notifikácie",
      "LOADING_MESSAGE": "Načítavajú sa notifikácie...",
      "TABLE_HEADER": [
        "Meno",
        "Telefónne číslo",
        "Konverzácie",
        "Naposledy kontaktovaný"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nová konverzácia",
      "conversation_assignment": "Konverzácia pridelená",
      "assigned_conversation_new_message": "Nová správa",
      "participating_conversation_new_message": "Nová správa",
      "conversation_mention": "Zmienka",
      "sla_missed_first_response": "Porušenie SLA",
      "sla_missed_next_response": "Porušenie SLA",
      "sla_missed_resolution": "Porušenie SLA"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Obnovuje sa pripojenie...",
      "RECONNECT_SUCCESS": "Pripojenie obnovené"
    },
    "BUTTON": {
      "REFRESH": "Obnoviť"
    },
    "CONNECTION_LOST": {
      "TITLE": "Spojenie sa prerušilo",
      "DESCRIPTION": "Nepodarilo sa nám spojiť so serverom. Skontrolujte pripojenie a skúste to znova.",
      "RETRY": "Skúsiť znova"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Hľadať alebo ísť na",
    "SECTIONS": {
      "GENERAL": "Všeobecné",
      "REPORTS": "Reporty",
      "CONVERSATION": "Konverzácia",
      "BULK_ACTIONS": "Hromadné akcie",
      "CHANGE_ASSIGNEE": "Zmeniť prideleného agenta",
      "CHANGE_PRIORITY": "Zmeniť prioritu",
      "CHANGE_TEAM": "Zmeniť tím",
      "SNOOZE_CONVERSATION": "Odložiť konverzáciu",
      "EXECUTE_MACRO": "Spustiť makro",
      "ADD_LABEL": "Pridať štítok do konverzácie",
      "REMOVE_LABEL": "Odstrániť štítok z konverzácie",
      "SETTINGS": "Nastavenia",
      "AI_ASSIST": "AI asistent",
      "APPEARANCE": "Vzhľad",
      "SNOOZE_NOTIFICATION": "Odložiť upozornenie"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Prejsť na ovládací panel konverzácie",
      "GO_TO_CONTACTS_DASHBOARD": "Prejsť na ovládací panel kontaktov",
      "GO_TO_REPORTS_OVERVIEW": "Prejsť na prehľad reportov",
      "GO_TO_CONVERSATION_REPORTS": "Prejsť na reporty konverzácií",
      "GO_TO_AGENT_REPORTS": "Prejsť na reporty o agentoch",
      "GO_TO_LABEL_REPORTS": "Prejsť na reporty o štítkoch",
      "GO_TO_INBOX_REPORTS": "Prejsť na reporty o schránkach",
      "GO_TO_TEAM_REPORTS": "Prejsť na reporty o tímoch",
      "GO_TO_SETTINGS_AGENTS": "Prejsť na nastavenia agentov",
      "GO_TO_SETTINGS_TEAMS": "Prejsť na nastavenia tímov",
      "GO_TO_SETTINGS_INBOXES": "Prejsť na nastavenia chránok",
      "GO_TO_SETTINGS_LABELS": "Prejsť na nastavenia štítkov",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Prejsť na nastavenia uložených odpovedí",
      "GO_TO_SETTINGS_APPLICATIONS": "Prejsť na nastavenia aplikácií",
      "GO_TO_SETTINGS_ACCOUNT": "Prejsť na nastavenia účtu",
      "GO_TO_SETTINGS_PROFILE": "Prejsť na nastavenia profilu",
      "GO_TO_NOTIFICATIONS": "Prejsť na upozornenia",
      "ADD_LABELS_TO_CONVERSATION": "Pridať štítok do konverzácie",
      "ASSIGN_AN_AGENT": "Priradiť agenta",
      "AI_ASSIST": "AI asistent",
      "ASSIGN_PRIORITY": "Priradiť prioritu",
      "ASSIGN_A_TEAM": "Priradiť tím",
      "EXECUTE_A_MACRO": "Spustiť makro",
      "MUTE_CONVERSATION": "Stlmiť konverzáciu",
      "UNMUTE_CONVERSATION": "Zrušiť stlmenie konverzácie",
      "REMOVE_LABEL_FROM_CONVERSATION": "Odstrániť štítok z konverzácie",
      "REOPEN_CONVERSATION": "Znovu otvoriť konverzáciu",
      "RESOLVE_CONVERSATION": "Vyriešiť konverzáciu",
      "SEND_TRANSCRIPT": "Odoslať prepis e-mailom",
      "SNOOZE_CONVERSATION": "Odložiť konverzáciu",
      "UNTIL_NEXT_REPLY": "Do ďalšej odpovede",
      "UNTIL_NEXT_WEEK": "Do budúceho týždňa",
      "UNTIL_TOMORROW": "Do zajtra",
      "UNTIL_NEXT_MONTH": "Do budúceho mesiaca",
      "AN_HOUR_FROM_NOW": "Za hodinu od teraz",
      "UNTIL_CUSTOM_TIME": "Vlastné...",
      "CHANGE_APPEARANCE": "Zmeniť vzhľad",
      "LIGHT_MODE": "Svetlý",
      "DARK_MODE": "Tmavý",
      "SYSTEM_MODE": "Systémový",
      "SNOOZE_NOTIFICATION": "Odložiť upozornenie"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Načítava sa aplikácia dashboardu..."
  },
  "COMMON": {
    "OR": "Alebo",
    "CLICK_HERE": "kliknite sem"
  }
}
